import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsService } from 'src/app/services/reports.service';
import { MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { DatePipe } from '@angular/common';

interface SubsidyData {
  Activities: string;
  'F.Y.': string;
  'No. of Lots'?: number; // Optional, since some tables don't have this
  'Success Applications': number;
  'Success Amount': number;
  'Error Applications': number;
  'Error Amount': number;
}

interface SubsidyDataFormat5 {
  Activities: string;
  Type: string; // Renamed from Caste_Description

  // Financial Year 2022-23
  'Lots 2022-23': number;
  'Success Applications 2022-23': number;
  'Success Amount 2022-23': number;
  'Error Applications 2022-23': number;
  'Error Amount 2022-23': number;

  // Financial Year 2023-24
  'Lots 2023-24': number;
  'Success Applications 2023-24': number;
  'Success Amount 2023-24': number;
  'Error Applications 2023-24': number;
  'Error Amount 2023-24': number;

  // Financial Year 2024-25
  'Lots 2024-25': number;
  'Success Applications 2024-25': number;
  'Success Amount 2024-25': number;
  'Error Applications 2024-25': number;
  'Error Amount 2024-25': number;
}

// Interface for FormatType=6 (Table 6)
interface SubsidyDataFormat6 {
  Activities: string;
  Type: string; // Renamed from Program_Name

  // Financial Year 2022-23
  'Lots 2022-23': number;
  'Success Applications 2022-23': number;
  'Success Amount 2022-23': number;
  'Error Applications 2022-23': number;
  'Error Amount 2022-23': number;

  // Financial Year 2023-24
  'Lots 2023-24': number;
  'Success Applications 2023-24': number;
  'Success Amount 2023-24': number;
  'Error Applications 2023-24': number;
  'Error Amount 2023-24': number;

  // Financial Year 2024-25
  'Lots 2024-25': number;
  'Success Applications 2024-25': number;
  'Success Amount 2024-25': number;
  'Error Applications 2024-25': number;
  'Error Amount 2024-25': number;
}

// New interface for FormatType=3 (Table 3)
interface SubsidyDataFormat3 {
  Activities: string; // Mapped from LotType

  'Applications 2022-23': number;
  'Amount 2022-23': number;
  'Applications 2023-24': number;
  'Amount 2023-24': number;
  'Applications 2024-25': number;
  'Amount 2024-25': number;

  'Total Applications': number;
  'Total Amount': number;
}

@Component({
  selector: 'app-subsidy-distribution',
  templateUrl: './subsidy-distribution.component.html',
  styleUrls: ['./subsidy-distribution.component.scss'],
  providers: [DatePipe],
})
export class SubsidyDistributionComponent implements OnInit {
  tableItems1: MenuItem[];
  tableItems2: MenuItem[];
  tableItems3: MenuItem[];
  tableItems4: MenuItem[];
  tableItems4b: MenuItem[];
  tableItems5: MenuItem[];
  tableItems6: MenuItem[];
  
  // Properties for Non-Tank Activities (First Table)
  dataFormatType2_nonTank: SubsidyData[] = [];
  rowSpan2_nonTank: { [key: string]: number } = {};
  loadingTable2_nonTank: boolean = true;

  grandTotalSuccessApplications2_nonTank: number = 0;
  grandTotalSuccessAmount2_nonTank: number = 0;
  grandTotalErrorApplications2_nonTank: number = 0;
  grandTotalErrorAmount2_nonTank: number = 0;

  // Properties for Tank Activities (New Table)
  dataFormatType2_tank: SubsidyData[] = [];
  rowSpan2_tank: { [key: string]: number } = {};
  loadingTable2_tank: boolean = true;

  grandTotalSuccessApplications2_tank: number = 0;
  grandTotalSuccessAmount2_tank: number = 0;
  grandTotalErrorApplications2_tank: number = 0;
  grandTotalErrorAmount2_tank: number = 0;

  // Properties for Table 3 (FormatType=3)
  dataFormatType3: SubsidyDataFormat3[] = [];
  loadingTable3: boolean = true;
  grandTotals3: { [key: string]: number } = {}; // Grand totals for Table 3

  // Properties for Table 4 (FormatType=4)
  dataFormatType4: SubsidyData[] = [];
  loadingTable4: boolean = true;
  rowSpan4: { [key: string]: number } = {};
  // Grand totals for Table 4
  grandTotalSuccessApplications4: number = 0;
  grandTotalSuccessAmount4: number = 0;
  grandTotalErrorApplications4: number = 0;
  grandTotalErrorAmount4: number = 0;
  grandTotalNoOfLots4: number = 0; // For 'No. of Lots'

  // Properties for Table 5 (FormatType=5)
  dataFormatType5: SubsidyDataFormat5[] = [];
  casteWiseDataType5: any = [];
  loadingTable5: boolean = true;
  rowSpan5: { [key: string]: number } = {};
  grandTotals5: { [key: string]: number } = {}; // Grand totals for Table 5

  // Properties for Table 6 (FormatType=6)
  dataFormatType4b: SubsidyDataFormat6[] = [];
  dataFormatType6: SubsidyDataFormat6[] = [];
  loadingTable6: boolean = true;
  rowSpan6: { [key: string]: number } = {};
  rowSpan4b: { [key: string]: number } = {};
  grandTotals6: { [key: string]: number } = {}; // Grand totals for Table 6
  grandTotals4b: { [key: string]: number } = {}; // Grand totals for Table 6

  public showSubsidyToFarmer: boolean = false;
  public showSubsidyToVendor: boolean = false;
  public showRefundToFarmer: boolean = false;
  public showFarmerShareToVendor: boolean = false;
  public selectedRowVal: any;
  public showTanksS1: boolean = false;
  public showTanksS2: boolean = false;
  public showTanksS3: boolean = false;
  public showTable1Lot: boolean = false;
  public showTable2Lot: boolean = false;
  public showTable4Lot: boolean = false;
  
  public drillDownReqDetails: any;
  public showDrillDownReport: boolean = false;

  public exportColumns: any;
  public todayDate: any;


  constructor(
    private http: HttpClient,
    private reportsService: ReportsService,
    private messageService: MessageService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.todayDate = this.datePipe.transform(new Date(), 'dd-MM-yyyy'),
    this.fetchDataForTable2();
    this.fetchDataForTable3(); // Fetch data for the new table
    this.fetchDataForTable4();
    this.fetchDataForTable5();
    this.fetchDataForTable6();

    this.tableItems1 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT1(this.dataFormatType2_nonTank, 'Table1');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT1(this.dataFormatType2_nonTank, 'Table1');
        }
      },
    ];

    this.tableItems2 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT2(this.dataFormatType2_tank, 'Table2');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT2(this.dataFormatType2_tank, 'Table2');
        }
      },
    ];

    this.tableItems3 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT3(this.dataFormatType3, 'Table3');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT3(this.dataFormatType3, 'Table3');
        }
      },
    ];

    this.tableItems4 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT4A(this.dataFormatType4, 'Table4(a)');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT4A(this.dataFormatType4, 'Table4(a)');
        }
      },
    ];
    this.tableItems4b = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT4b(this.dataFormatType4b, 'Table4(b)');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT4b(this.dataFormatType4b, 'Table4(b)');
        }
      },
    ];
    this.tableItems5 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT5(this.dataFormatType6, 'Table5');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT5(this.dataFormatType6, 'Table5');
        }
      },
    ];
    this.tableItems6 = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelT6(this.dataFormatType5, 'Table6');
        },
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdfT6(this.dataFormatType5, 'Table6');
        }
      },
    ];
  }

  exportExcelT6(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      // const title = [["Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 6"];
      const headerRow2 = ["", "", "", "", "", "F.Y -", "", "", "", "", "", "F.Y 2022-23", "", "", "", "", "", "F.Y 2023-24", "", "", "", "", "", "F.Y 2024-25", "", ""];
      const headerRow3 = ["", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", "", "", "",  "Success", "", "Error", "", "", "", "Success", "", "Error", ""];
      const headerRow4 = [
        "Activities", "Type", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d['Activities'], d['Type'], '', 
          d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '',
          d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
          d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
          d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        // ...title,
        ...downloadDate,
        // [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        headerRow4,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT6(modelData, filename) {
    if (!modelData) {
        modelData = [];
    }

    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            // Title and subtitle
            const title = "";
            const downloadDate = `(Export Date: ${this.todayDate})`

            // Add title
            doc.setFontSize(4);  // Reduced font size for the title
            doc.text(title, 14, 15); // Title at x=14, y=15

            // Add download Date
            doc.setFontSize(6);
            doc.text(downloadDate, 14, 20);

            // Define custom headers
            const headerRow1 = [{ content: 'Table - 6', colSpan: 26, styles: { halign: 'center', fontStyle: 'bold' } }];
            const headerRow2 = [
                { content: '', colSpan: 5 }, // Empty cells for alignment
                { content: 'F.Y -', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2022-23', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2023-24', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2024-25', colSpan: 5, styles: { halign: 'center' } }
            ];
            const headerRow3 = [
                '', '', '', '', 
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', ''
            ];
            const headerRow4 = [
                "Activities", "Type", '', 
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount"
            ];

            // Mapping model data to match the table structure
            const dataToSave = modelData.map((d: any) => {
                return [
                    d['Activities'], d['Type'], '', 
                    d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '',
                    d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
                    d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
                    d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
                ];
            });

            // Calculate grand totals for Applications and Amounts for Success and Error columns
            const grandTotal = {
                lots_: modelData.reduce((sum, d) => sum + (d['Lots 2022-23'] || 0), 0),
                successApplications_: modelData.reduce((sum, d) => sum + (d['Success Applications 2022-23'] || 0), 0),
                successAmount_: modelData.reduce((sum, d) => sum + (d['Success Amount 2022-23'] || 0), 0),
                errorApplications_: modelData.reduce((sum, d) => sum + (d['Error Applications 2022-23'] || 0), 0),
                errorAmount_: modelData.reduce((sum, d) => sum + (d['Error Amount 2022-23'] || 0), 0),
                
                lots2022_23: modelData.reduce((sum, d) => sum + (d['Lots 2022-23'] || 0), 0),
                successApplications2022_23: modelData.reduce((sum, d) => sum + (d['Success Applications 2022-23'] || 0), 0),
                successAmount2022_23: modelData.reduce((sum, d) => sum + (d['Success Amount 2022-23'] || 0), 0),
                errorApplications2022_23: modelData.reduce((sum, d) => sum + (d['Error Applications 2022-23'] || 0), 0),
                errorAmount2022_23: modelData.reduce((sum, d) => sum + (d['Error Amount 2022-23'] || 0), 0),

                lots2023_24: modelData.reduce((sum, d) => sum + (d['Lots 2023-24'] || 0), 0),
                successApplications2023_24: modelData.reduce((sum, d) => sum + (d['Success Applications 2023-24'] || 0), 0),
                successAmount2023_24: modelData.reduce((sum, d) => sum + (d['Success Amount 2023-24'] || 0), 0),
                errorApplications2023_24: modelData.reduce((sum, d) => sum + (d['Error Applications 2023-24'] || 0), 0),
                errorAmount2023_24: modelData.reduce((sum, d) => sum + (d['Error Amount 2023-24'] || 0), 0),

                lots2024_25: modelData.reduce((sum, d) => sum + (d['Lots 2024-25'] || 0), 0),
                successApplications2024_25: modelData.reduce((sum, d) => sum + (d['Success Applications 2024-25'] || 0), 0),
                successAmount2024_25: modelData.reduce((sum, d) => sum + (d['Success Amount 2024-25'] || 0), 0),
                errorApplications2024_25: modelData.reduce((sum, d) => sum + (d['Error Applications 2024-25'] || 0), 0),
                errorAmount2024_25: modelData.reduce((sum, d) => sum + (d['Error Amount 2024-25'] || 0), 0),
            };

            // Add grand total row directly into the main table data
            dataToSave.push([
                { content: 'Grand Total', colSpan: 3, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center' } }, // Grand Total label
                grandTotal.lots_, grandTotal.successApplications_, grandTotal.successAmount_, grandTotal.errorApplications_, grandTotal.errorAmount_, '',
                grandTotal.lots2022_23, grandTotal.successApplications2022_23, grandTotal.successAmount2022_23, grandTotal.errorApplications2022_23, grandTotal.errorAmount2022_23, '',
                grandTotal.lots2023_24, grandTotal.successApplications2023_24, grandTotal.successAmount2023_24, grandTotal.errorApplications2023_24, grandTotal.errorAmount2023_24, '',
                grandTotal.lots2024_25, grandTotal.successApplications2024_25, grandTotal.successAmount2024_25, grandTotal.errorApplications2024_25, grandTotal.errorAmount2024_25
            ]);

            // Add table with headers and data including grand total
            doc.autoTable({
                startY: 25, // Start after the title
                head: [headerRow1, headerRow2, headerRow3, headerRow4],
                body: dataToSave,
                theme: 'grid', // Grid layout for the table
                headStyles: { fillColor: [41, 128, 185] }, // Blue header background
                bodyStyles: { fontSize: 6 }, // Adjusted font size for the data
                columnStyles: {
                  4: { fillColor: [144, 238, 144] }, // Success Applications (-) in light green
                  5: { fillColor: [144, 238, 144] }, // Success Amount (-)
                  6: { fillColor: [255, 182, 193] }, // Error Applications (-) in light red
                  7: { fillColor: [255, 182, 193] }, // Error Amount (-)

                  10: { fillColor: [144, 238, 144] }, // Success Applications (2022-23) in light green
                  11: { fillColor: [144, 238, 144] }, // Success Amount (2022-23)
                  12: { fillColor: [255, 182, 193] }, // Error Applications (2022-23) in light red
                  13: { fillColor: [255, 182, 193] }, // Error Amount (2022-23)

                  16: { fillColor: [144, 238, 144] }, // Success Applications (2023-24)
                  17: { fillColor: [144, 238, 144] }, // Success Amount (2023-24)
                  18: { fillColor: [255, 182, 193] }, // Error Applications (2023-24)
                  19: { fillColor: [255, 182, 193] }, // Error Amount (2023-24)

                  22: { fillColor: [144, 238, 144] }, // Success Applications (2024-25)
                  23: { fillColor: [144, 238, 144] }, // Success Amount (2024-25)
                  24: { fillColor: [255, 182, 193] }, // Error Applications (2024-25)
                  25: { fillColor: [255, 182, 193] }, // Error Amount (2024-25)
                },
                // Customize the grand total row styles separately
                didParseCell: (data) => {
                    if (data.row.index === data.table.body.length - 1) { // If it's the last row (Grand Total)
                        data.cell.styles.fillColor = [0, 0, 0]; // Set background to black
                        data.cell.styles.textColor = [255, 255, 255]; // Set text color to white
                        data.cell.styles.fontStyle = 'bold'; // Set font style to bold
                    }
                },
                footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' }, // Footer row (Grand Total) style
                styles: {
                    fontSize: 6 // Reduced font size for the entire table
                }
            });

            // Save the PDF
            doc.save(filename + ".pdf");
        });
    });
  }

  exportExcelT5(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      // const title = [["Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 5"];
      const headerRow2 = ["", "", "", "", "", "F.Y -", "", "", "", "", "", "F.Y 2022-23", "", "", "", "", "", "F.Y 2023-24", "", "", "", "", "", "F.Y 2024-25", "", ""];
      const headerRow3 = ["", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", ""];
      const headerRow4 = [
        "Activities", "Type", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d['Activities'], d['Type'], '', 
          d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '',
          d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
          d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
          d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        // ...title,
        ...downloadDate,
        // [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        headerRow4,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT5(modelData, filename) {
    if (!modelData) {
        modelData = [];
    }

    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            // Title and subtitle
            const title = "";
            const downloadDate = `Export Date: ${this.todayDate}`

            // Add title
            doc.setFontSize(6);  // Reduced font size for the title
            doc.text(title, 14, 15); // Title at x=14, y=15

            // Add download Date
            doc.setFontSize(6);
            doc.text(downloadDate, 14, 20);

            // Define custom headers
            const headerRow1 = [{ content: 'Table - 5', colSpan: 26, styles: { halign: 'center', fontStyle: 'bold' } }];
            const headerRow2 = [
                { content: '', colSpan: 5 }, // Empty cells for alignment
                { content: 'F.Y -', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2022-23', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2023-24', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2024-25', colSpan: 5, styles: { halign: 'center' } }
            ];
            const headerRow3 = [
                '', '', '', '', 
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', ''
            ];
            const headerRow4 = [
                "Activities", "Type", '', 
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount"
            ];

            // Mapping model data to match the table structure
            const dataToSave = modelData.map((d: any) => {
                return [
                    d['Activities'], d['Type'], '',
                    d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '',
                    d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
                    d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
                    d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
                ];
            });

            // Calculate grand totals for Applications and Amounts for Success and Error columns
            const grandTotal = {
                lots_: modelData.reduce((sum, d) => sum + (d['Lots -'] || 0), 0),
                successApplications_: modelData.reduce((sum, d) => sum + (d['Success Applications -'] || 0), 0),
                successAmount_: modelData.reduce((sum, d) => sum + (d['Success Amount -'] || 0), 0),
                errorApplications_: modelData.reduce((sum, d) => sum + (d['Error Applications -'] || 0), 0),
                errorAmount_: modelData.reduce((sum, d) => sum + (d['Error Amount -'] || 0), 0),
                
                lots2022_23: modelData.reduce((sum, d) => sum + (d['Lots 2022-23'] || 0), 0),
                successApplications2022_23: modelData.reduce((sum, d) => sum + (d['Success Applications 2022-23'] || 0), 0),
                successAmount2022_23: modelData.reduce((sum, d) => sum + (d['Success Amount 2022-23'] || 0), 0),
                errorApplications2022_23: modelData.reduce((sum, d) => sum + (d['Error Applications 2022-23'] || 0), 0),
                errorAmount2022_23: modelData.reduce((sum, d) => sum + (d['Error Amount 2022-23'] || 0), 0),

                lots2023_24: modelData.reduce((sum, d) => sum + (d['Lots 2023-24'] || 0), 0),
                successApplications2023_24: modelData.reduce((sum, d) => sum + (d['Success Applications 2023-24'] || 0), 0),
                successAmount2023_24: modelData.reduce((sum, d) => sum + (d['Success Amount 2023-24'] || 0), 0),
                errorApplications2023_24: modelData.reduce((sum, d) => sum + (d['Error Applications 2023-24'] || 0), 0),
                errorAmount2023_24: modelData.reduce((sum, d) => sum + (d['Error Amount 2023-24'] || 0), 0),

                lots2024_25: modelData.reduce((sum, d) => sum + (d['Lots 2024-25'] || 0), 0),
                successApplications2024_25: modelData.reduce((sum, d) => sum + (d['Success Applications 2024-25'] || 0), 0),
                successAmount2024_25: modelData.reduce((sum, d) => sum + (d['Success Amount 2024-25'] || 0), 0),
                errorApplications2024_25: modelData.reduce((sum, d) => sum + (d['Error Applications 2024-25'] || 0), 0),
                errorAmount2024_25: modelData.reduce((sum, d) => sum + (d['Error Amount 2024-25'] || 0), 0),
            };

            // Add grand total row directly into the main table data
            dataToSave.push([
                { content: 'Grand Total', colSpan: 3, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center' } }, // Grand Total label
                grandTotal.lots2022_23, grandTotal.successApplications_, grandTotal.successAmount_, grandTotal.errorApplications_, grandTotal.errorAmount_, '',
                grandTotal.lots2022_23, grandTotal.successApplications2022_23, grandTotal.successAmount2022_23, grandTotal.errorApplications2022_23, grandTotal.errorAmount2022_23, '',
                grandTotal.lots2023_24, grandTotal.successApplications2023_24, grandTotal.successAmount2023_24, grandTotal.errorApplications2023_24, grandTotal.errorAmount2023_24, '',
                grandTotal.lots2024_25, grandTotal.successApplications2024_25, grandTotal.successAmount2024_25, grandTotal.errorApplications2024_25, grandTotal.errorAmount2024_25
            ]);

            // Add table with headers and data including grand total
            doc.autoTable({
                startY: 25, // Start after the title
                head: [headerRow1, headerRow2, headerRow3, headerRow4],
                body: dataToSave,
                theme: 'grid', // Grid layout for the table
                headStyles: { fillColor: [41, 128, 185] }, // Blue header background
                bodyStyles: { fontSize: 6 }, // Adjusted font size for the data
                columnStyles: {
                  4: { fillColor: [144, 238, 144] }, // Success Applications (-) in light green
                  5: { fillColor: [144, 238, 144] }, // Success Amount (-)
                  6: { fillColor: [255, 182, 193] }, // Error Applications (-) in light red
                  7: { fillColor: [255, 182, 193] }, // Error Amount (-)

                  10: { fillColor: [144, 238, 144] }, // Success Applications (2022-23) in light green
                  11: { fillColor: [144, 238, 144] }, // Success Amount (2022-23)
                  12: { fillColor: [255, 182, 193] }, // Error Applications (2022-23) in light red
                  13: { fillColor: [255, 182, 193] }, // Error Amount (2022-23)

                  16: { fillColor: [144, 238, 144] }, // Success Applications (2023-24)
                  17: { fillColor: [144, 238, 144] }, // Success Amount (2023-24)
                  18: { fillColor: [255, 182, 193] }, // Error Applications (2023-24)
                  19: { fillColor: [255, 182, 193] }, // Error Amount (2023-24)

                  22: { fillColor: [144, 238, 144] }, // Success Applications (2024-25)
                  23: { fillColor: [144, 238, 144] }, // Success Amount (2024-25)
                  24: { fillColor: [255, 182, 193] }, // Error Applications (2024-25)
                  25: { fillColor: [255, 182, 193] }, // Error Amount (2024-25)
                },
                // Customize the grand total row styles separately
                didParseCell: (data) => {
                    if (data.row.index === data.table.body.length - 1) { // If it's the last row (Grand Total)
                        data.cell.styles.fillColor = [0, 0, 0]; // Set background to black
                        data.cell.styles.textColor = [255, 255, 255]; // Set text color to white
                        data.cell.styles.fontStyle = 'bold'; // Set font style to bold
                    }
                },
                footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' }, // Footer row (Grand Total) style
                styles: {
                    fontSize: 5 // Reduced font size for the entire table
                }
            });

            // Save the PDF
            doc.save(filename + ".pdf");
        });
    });
  }

  exportExcelT4b(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      const title = [["System Wise Bifurcation of FTV"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 4 (b)"];
      const headerRow2 = ["", "", "", "", "", "F.Y -", "", "", "", "", "", "F.Y 2022-23", "", "", "", "", "", "F.Y 2023-24", "", "", "", "", "", "F.Y 2024-25", "", ""];
      const headerRow3 = ["", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", "", "", "", "Success", "", "Error", ""];
      const headerRow4 = [
        "Activities", "Type", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount", '', "Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d['Activities'], d['Type'], '',
          d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '', 
          d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
          d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
          d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        ...title,
        ...downloadDate,
        // [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        headerRow4,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT4b(modelData, filename) {
    if (!modelData) {
        modelData = [];
    }

    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            // Title and subtitle
            const title = "System Wise Bifurcation of FTV";
            const downloadDate = `Export Date: ${this.todayDate}`

            // Add title
            doc.setFontSize(6);  // Reduced font size for the title
            doc.text(title, 14, 15); // Title at x=14, y=15

            // Add download Date
            doc.setFontSize(6);
            doc.text(downloadDate, 14, 20);

            // Define custom headers
            const headerRow1 = [{ content: 'Table - 4(b)', colSpan: 26, styles: { halign: 'center', fontStyle: 'bold' } }];
            const headerRow2 = [
                { content: '', colSpan: 5 }, // Empty cells for alignment
                { content: 'F.Y -', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2022-23', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2023-24', colSpan: 5, styles: { halign: 'center' } },
                { content: 'F.Y 2024-25', colSpan: 5, styles: { halign: 'center' } }
            ];
            const headerRow3 = [
                '', '', '', '', 
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', '', '',
                'Success', '', 'Error', '', ''
            ];
            const headerRow4 = [
                "Activities", "Type", '', 
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount", '',
                "Lots", "Applications", "Amount", "Applications", "Amount"
            ];

            // Mapping model data to match the table structure
            const dataToSave = modelData.map((d: any) => {
                return [
                    d['Activities'], d['Type'], '', 
                    d['Lots -'], d['Success Applications -'], d['Success Amount -'], d['Error Applications -'], d['Error Amount -'], '',
                    d['Lots 2022-23'], d['Success Applications 2022-23'], d['Success Amount 2022-23'], d['Error Applications 2022-23'], d['Error Amount 2022-23'], '',
                    d['Lots 2023-24'], d['Success Applications 2023-24'], d['Success Amount 2023-24'], d['Error Applications 2023-24'], d['Error Amount 2023-24'], '',
                    d['Lots 2024-25'], d['Success Applications 2024-25'], d['Success Amount 2024-25'], d['Error Applications 2024-25'], d['Error Amount 2024-25'],
                ];
            });

            // Calculate grand totals for Applications and Amounts for Success and Error columns
            const grandTotal = {
                lots_: modelData.reduce((sum, d) => sum + (d['Lots -'] || 0), 0),
                successApplications_: modelData.reduce((sum, d) => sum + (d['Success Applications -'] || 0), 0),
                successAmount_: modelData.reduce((sum, d) => sum + (d['Success Amount -'] || 0), 0),
                errorApplications_: modelData.reduce((sum, d) => sum + (d['Error Applications -'] || 0), 0),
                errorAmount_: modelData.reduce((sum, d) => sum + (d['Error Amount -'] || 0), 0),
                
                lots2022_23: modelData.reduce((sum, d) => sum + (d['Lots 2022-23'] || 0), 0),
                successApplications2022_23: modelData.reduce((sum, d) => sum + (d['Success Applications 2022-23'] || 0), 0),
                successAmount2022_23: modelData.reduce((sum, d) => sum + (d['Success Amount 2022-23'] || 0), 0),
                errorApplications2022_23: modelData.reduce((sum, d) => sum + (d['Error Applications 2022-23'] || 0), 0),
                errorAmount2022_23: modelData.reduce((sum, d) => sum + (d['Error Amount 2022-23'] || 0), 0),

                lots2023_24: modelData.reduce((sum, d) => sum + (d['Lots 2023-24'] || 0), 0),
                successApplications2023_24: modelData.reduce((sum, d) => sum + (d['Success Applications 2023-24'] || 0), 0),
                successAmount2023_24: modelData.reduce((sum, d) => sum + (d['Success Amount 2023-24'] || 0), 0),
                errorApplications2023_24: modelData.reduce((sum, d) => sum + (d['Error Applications 2023-24'] || 0), 0),
                errorAmount2023_24: modelData.reduce((sum, d) => sum + (d['Error Amount 2023-24'] || 0), 0),

                lots2024_25: modelData.reduce((sum, d) => sum + (d['Lots 2024-25'] || 0), 0),
                successApplications2024_25: modelData.reduce((sum, d) => sum + (d['Success Applications 2024-25'] || 0), 0),
                successAmount2024_25: modelData.reduce((sum, d) => sum + (d['Success Amount 2024-25'] || 0), 0),
                errorApplications2024_25: modelData.reduce((sum, d) => sum + (d['Error Applications 2024-25'] || 0), 0),
                errorAmount2024_25: modelData.reduce((sum, d) => sum + (d['Error Amount 2024-25'] || 0), 0),
            };

            // Add grand total row directly into the main table data
            dataToSave.push([
                { content: 'Grand Total', colSpan: 3, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold', halign: 'center' } }, // Grand Total label
                grandTotal.lots_, grandTotal.successApplications_, grandTotal.successAmount_, grandTotal.errorApplications_, grandTotal.errorAmount_, '',
                grandTotal.lots2022_23, grandTotal.successApplications2022_23, grandTotal.successAmount2022_23, grandTotal.errorApplications2022_23, grandTotal.errorAmount2022_23, '',
                grandTotal.lots2023_24, grandTotal.successApplications2023_24, grandTotal.successAmount2023_24, grandTotal.errorApplications2023_24, grandTotal.errorAmount2023_24, '',
                grandTotal.lots2024_25, grandTotal.successApplications2024_25, grandTotal.successAmount2024_25, grandTotal.errorApplications2024_25, grandTotal.errorAmount2024_25
            ]);

            // Add table with headers and data including grand total
            doc.autoTable({
                startY: 25, // Start after the title
                head: [headerRow1, headerRow2, headerRow3, headerRow4],
                body: dataToSave,
                theme: 'grid', // Grid layout for the table
                headStyles: { fillColor: [41, 128, 185] }, // Blue header background
                bodyStyles: { fontSize: 6 }, // Adjusted font size for the data
                columnStyles: {
                    4: { fillColor: [144, 238, 144] }, // Success Applications (-) in light green
                    5: { fillColor: [144, 238, 144] }, // Success Amount (-)
                    6: { fillColor: [255, 182, 193] }, // Error Applications (-) in light red
                    7: { fillColor: [255, 182, 193] }, // Error Amount (-)

                    10: { fillColor: [144, 238, 144] }, // Success Applications (2022-23) in light green
                    11: { fillColor: [144, 238, 144] }, // Success Amount (2022-23)
                    12: { fillColor: [255, 182, 193] }, // Error Applications (2022-23) in light red
                    13: { fillColor: [255, 182, 193] }, // Error Amount (2022-23)

                    16: { fillColor: [144, 238, 144] }, // Success Applications (2023-24)
                    17: { fillColor: [144, 238, 144] }, // Success Amount (2023-24)
                    18: { fillColor: [255, 182, 193] }, // Error Applications (2023-24)
                    19: { fillColor: [255, 182, 193] }, // Error Amount (2023-24)

                    22: { fillColor: [144, 238, 144] }, // Success Applications (2024-25)
                    23: { fillColor: [144, 238, 144] }, // Success Amount (2024-25)
                    24: { fillColor: [255, 182, 193] }, // Error Applications (2024-25)
                    25: { fillColor: [255, 182, 193] }, // Error Amount (2024-25)
                },
                // Customize the grand total row styles separately
                didParseCell: (data) => {
                    if (data.row.index === data.table.body.length - 1) { // If it's the last row (Grand Total)
                        data.cell.styles.fillColor = [0, 0, 0]; // Set background to black
                        data.cell.styles.textColor = [255, 255, 255]; // Set text color to white
                        data.cell.styles.fontStyle = 'bold'; // Set font style to bold
                    }
                },
                footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' }, // Footer row (Grand Total) style
                styles: {
                    fontSize: 5 // Reduced font size for the entire table
                }
            });

            // Save the PDF
            doc.save(filename + ".pdf");
        });
    });
  }

  exportExcelT4A(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      const title = [["Gist of FTV: Year wise actual payment details to vendors as Farmer share"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 4(a)"];
      const headerRow2 = ["", "", "", "Success", "", "Errors"];
      const headerRow3 = [
        "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
          d['Error Applications'], d['Error Amount']
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        ...title,
        ...downloadDate,
        [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT4A(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
  
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
  
        // Title and subtitle
        const title = "Gist of FTV: Year wise actual payment details to vendors as Farmer share";
        const downloadDate = `(Export Date: ${this.todayDate})`
        const subtitle = "Table - 4(a)";
  
        // Add title
        doc.setFontSize(14);
        doc.text(title, 14, 15); // Title at x=14, y=15

        // Add download Date
        doc.setFontSize(12);
        doc.text(downloadDate, 14, 25);
  
        // Add subtitle
        doc.setFontSize(12);
        doc.text(subtitle, 14, 35); // Subtitle at x=14, y=25
  
        // Custom header rows
        const headerRow2 = [
          { content: '', colSpan: 3 }, // Empty cells for alignment
          { content: 'Success', colSpan: 2, styles: { halign: 'center' } },
          { content: 'Errors', colSpan: 2, styles: { halign: 'center' } }
        ];
  
        const headerRow3 = [
          "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
        ];
  
        // Mapping model data to match the Excel structure
        const dataToSave = modelData.map((d: any) => {
          return [
            d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
            d['Error Applications'], d['Error Amount']
          ];
        });
  
        // Calculate grand totals for Success Applications, Success Amount, Error Applications, and Error Amount
        const grandTotal = {
          activities: 'Grand Total',
          successApplications: modelData.reduce((sum, d) => sum + (d['Success Applications'] || 0), 0),
          successAmount: modelData.reduce((sum, d) => sum + (d['Success Amount'] || 0), 0),
          errorApplications: modelData.reduce((sum, d) => sum + (d['Error Applications'] || 0), 0),
          errorAmount: modelData.reduce((sum, d) => sum + (d['Error Amount'] || 0), 0)
        };
  
        // Add grand total row to the data
        // dataToSave.push([
        //   { content: grandTotal.activities, colSpan: 3, styles: { fontStyle: 'bold' } }, // Colspan applied to the first cell
        //   '', '', grandTotal.successApplications, grandTotal.successAmount,
        //   grandTotal.errorApplications, grandTotal.errorAmount
        // ]);
  
        // Add table with headers and data
        doc.autoTable({
          startY: 45, // Start after the subtitle
          head: [headerRow2, headerRow3],
          body: dataToSave,
          theme: 'grid', // Grid layout for the table
          headStyles: { fillColor: [41, 128, 185] }, // Blue header background
          bodyStyles: { fontSize: 10 }, // Body font size
          columnStyles: {
            3: { fillColor: [144, 238, 144] }, // Light green for "Success Applications"
            4: { fillColor: [144, 238, 144] }, // Light green for "Success Amount"
            5: { fillColor: [255, 182, 193] }, // Light red for "Error Applications"
            6: { fillColor: [255, 182, 193] }  // Light red for "Error Amount"
          },
          foot: [[
            { content: grandTotal.activities, colSpan: 3, styles: { fillColor: [0, 0, 0], fontStyle: 'bold', textColor: [255, 255, 255] } },
            { content: grandTotal.successApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.successAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } }
          ]],
          footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' } // Black background for the Grand Total row
        });
  
        // Save the generated PDF
        doc.save(`${filename}_export_${new Date().getTime()}.pdf`);
      });
    });
  }
  

  exportExcelT3(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      const title = [["Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 3"];
      const headerRow2 = ["", "F.Y -", "", "F.Y 2022-23", "", "F.Y 2023-24", "", "F.Y 2024-25", "", "Grand Total"];
      const headerRow3 = [
        "Activities", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d['Activities'], d['Applications -'], d['Amount -'], d['Applications 2022-23'], d['Amount 2022-23'], d['Applications 2023-24'], d['Amount 2023-24'],
          d['Applications 2024-25'], d['Amount 2024-25'], d['Total Applications'], d['Total Amount']
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        ...title,
        ...downloadDate,
        [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT3(modelData, filename) {
    if (!modelData) {
        modelData = [];
    }

    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(() => {
            const doc = new jsPDF.default({
                orientation: 'landscape', // Set the PDF to landscape format
                unit: 'mm',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            // Title and subtitle
            const title = "Gist of Expenditure in PDMC for installation of MI System & Construction of OFWT";
            const downloadDate = `Export Date: ${this.todayDate}`
            const subtitle = "Table - 3";

            // Add title
            doc.setFontSize(14);
            doc.text(title, 14, 15); // Title at x=14, y=15

            // Add download Date
            doc.setFontSize(12);
            doc.text(downloadDate, 14, 25);

            // Add subtitle
            doc.setFontSize(12);
            doc.text(subtitle, 14, 35); // Subtitle at x=14, y=25

            // Custom header rows
            const headerRow1 = [
                { content: '', colSpan: 1 }, // Empty cell for alignment
                { content: 'F.Y -', colSpan: 2, styles: { halign: 'center' } },
                { content: 'F.Y 2022-23', colSpan: 2, styles: { halign: 'center' } },
                { content: 'F.Y 2023-24', colSpan: 2, styles: { halign: 'center' } },
                { content: 'F.Y 2024-25', colSpan: 2, styles: { halign: 'center' } },
                { content: 'Grand Total', colSpan: 2, styles: { halign: 'center' } }
            ];

            const headerRow2 = [
                "Activities", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount", "Applications", "Amount"
            ];

            // Mapping model data to match the Excel structure
            const dataToSave = modelData.map((d: any) => {
                return [
                    d['Activities'],
                    d['Applications -'],
                    d['Amount -'],
                    d['Applications 2022-23'],
                    d['Amount 2022-23'],
                    d['Applications 2023-24'],
                    d['Amount 2023-24'],
                    d['Applications 2024-25'],
                    d['Amount 2024-25'],
                    d['Total Applications'],
                    d['Total Amount']
                ];
            });

            // Calculate grand totals for Applications and Amounts
            const grandTotal = {
                applications_: modelData.reduce((sum, d) => sum + (d['Applications -'] || 0), 0),
                amount_: modelData.reduce((sum, d) => sum + (d['Amount -'] || 0), 0),
                applications2022_23: modelData.reduce((sum, d) => sum + (d['Applications 2022-23'] || 0), 0),
                amount2022_23: modelData.reduce((sum, d) => sum + (d['Amount 2022-23'] || 0), 0),
                applications2023_24: modelData.reduce((sum, d) => sum + (d['Applications 2023-24'] || 0), 0),
                amount2023_24: modelData.reduce((sum, d) => sum + (d['Amount 2023-24'] || 0), 0),
                applications2024_25: modelData.reduce((sum, d) => sum + (d['Applications 2024-25'] || 0), 0),
                amount2024_25: modelData.reduce((sum, d) => sum + (d['Amount 2024-25'] || 0), 0),
                totalApplications: modelData.reduce((sum, d) => sum + (d['Total Applications'] || 0), 0),
                totalAmount: modelData.reduce((sum, d) => sum + (d['Total Amount'] || 0), 0)
            };

            // Add grand total row directly into the main table data
            dataToSave.push([
                { content: 'Grand Total', styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' } }, // Grand Total label
                { content: grandTotal.applications_, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.amount_, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.applications2022_23, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.amount2022_23, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.applications2023_24, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.amount2023_24, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.applications2024_25, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.amount2024_25, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.totalApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
                { content: grandTotal.totalAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } }
            ]);

            // Add table with headers and data including grand total
            doc.autoTable({
                startY: 45, // Start after the subtitle
                head: [headerRow1, headerRow2],
                body: dataToSave,
                theme: 'grid', // Grid layout for the table
                headStyles: { fillColor: [41, 128, 185] }, // Blue header background
                bodyStyles: { fontSize: 10 } // Body font size
            });

            // Save the generated PDF
            doc.save(`${filename}_export_${new Date().getTime()}.pdf`);
        });
    });
  }

  exportExcelT2(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      const title = [["Financial Progress under PDMC for MICADA Portal 2.0 (Tank)"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 2"];
      const headerRow2 = ["", "", "", "Success", "", "Errors"];
      const headerRow3 = [
        "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
          d['Error Applications'], d['Error Amount']
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        ...title,
        ...downloadDate,
        [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdfT2(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
  
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
  
        // Title and subtitle
        const title = "Financial Progress under PDMC for MICADA Portal 2.0 (Tank)";
        const downloadDate = `(Export Date: ${this.todayDate})`
        const subtitle = "Table - 2";
  
        // Add title
        doc.setFontSize(14);
        doc.text(title, 14, 15); // Title at x=14, y=15
  
        // Add download Date
        doc.setFontSize(12);
        doc.text(downloadDate, 14, 25);

        // Add subtitle
        doc.setFontSize(12);
        doc.text(subtitle, 14, 35); // Subtitle at x=14, y=25
  
        // Custom header rows
        const headerRow2 = [
          { content: '', colSpan: 3 }, // Empty cells for alignment
          { content: 'Success', colSpan: 2, styles: { halign: 'center' } },
          { content: 'Errors', colSpan: 2, styles: { halign: 'center' } }
        ];
  
        const headerRow3 = [
          "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
        ];
  
        // Mapping model data to match the Excel structure
        const dataToSave = modelData.map((d: any) => {
          return [
            d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
            d['Error Applications'], d['Error Amount']
          ];
        });
  
        // Calculate grand totals for Success Amount and Error Amount
        const grandTotal = {
          activities: 'Grand Total',
          successApplications: modelData.reduce((sum, d) => sum + (d['Success Applications'] || 0), 0),
          successAmount: modelData.reduce((sum, d) => sum + (d['Success Amount'] || 0), 0),
          errorApplications: modelData.reduce((sum, d) => sum + (d['Error Applications'] || 0), 0),
          errorAmount: modelData.reduce((sum, d) => sum + (d['Error Amount'] || 0), 0)
        };
  
        // Add grand total row to the data
        // dataToSave.push([
        //   { content: grandTotal.activities, colSpan: 3 }, // Colspan applied to the first cell
        //   '', '', grandTotal.successApplications, grandTotal.successAmount,
        //   grandTotal.errorApplications, grandTotal.errorAmount
        // ]);
  
        // Add table with headers and data
        doc.autoTable({
          startY: 45, // Start after the subtitle
          head: [headerRow2, headerRow3],
          body: dataToSave,
          theme: 'grid', // Grid layout for the table
          headStyles: { fillColor: [41, 128, 185] }, // Blue header background
          bodyStyles: { fontSize: 10 }, // Body font size
          columnStyles: {
            3: { fillColor: [144, 238, 144] }, // Light green for "Success Applications"
            4: { fillColor: [144, 238, 144] }, // Light green for "Success Amount"
            5: { fillColor: [255, 182, 193] }, // Light red for "Error Applications"
            6: { fillColor: [255, 182, 193] }, // Light red for "Error Amount"
          },
          foot: [[
            { content: grandTotal.activities, colSpan: 3, styles: { fillColor: [0, 0, 0], fontStyle: 'bold', textColor: [255, 255, 255] } },
            { content: grandTotal.successApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.successAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } }
          ]],
          footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' } // Black background for the Grand Total row
        });
  
        // Save the generated PDF
        doc.save(`${filename}_export_${new Date().getTime()}.pdf`);
      });
    });
  }
  

  exportExcelT1(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      // Custom header rows based on the Excel table structure
      const title = [["Financial Progress under PDMC for MICADA Portal 2.0 (MI)"]];
      const downloadDate = [[`Export Date: ${this.todayDate}`]]
      const headerRow1 = ["Table - 1"];
      const headerRow2 = ["", "", "", "Success", "", "Errors"];
      const headerRow3 = [
        "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
      ];
  
      // Mapping model data to the structure
      const dataToSave = modelData.map((d: any) => {
        return [
          d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
          d['Error Applications'], d['Error Amount']
        ];
      });
  
      // Combine title, headers, and data
      const finalData = [
        ...title,
        ...downloadDate,
        [],
        headerRow1,
        [],
        headerRow2,
        headerRow3,
        ...dataToSave
      ];

      const worksheet = xlsx.utils.aoa_to_sheet(finalData); 
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }


  downloadSheetAsPdf1(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
  
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
  
        // Title and subtitle
        const title = "Financial Progress under PDMC for MICADA Portal 2.0 (MI)";
        const subtitle = "Table - 1";
  
        // Add title
        doc.setFontSize(14);
        doc.text(title, 14, 15); // Title at x=14, y=15
  
        // Add subtitle
        doc.setFontSize(12);
        doc.text(subtitle, 14, 25); // Subtitle at x=14, y=25
  
        // Custom header rows
        const headerRow2 = [
          { content: '', colSpan: 3 }, // Empty cells for alignment
          { content: 'Success', colSpan: 2, styles: { halign: 'center' } },
          { content: 'Errors', colSpan: 2, styles: { halign: 'center' } }
        ];
  
        const headerRow3 = [
          "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
        ];
  
        // Mapping model data to match the Excel structure
        const dataToSave = modelData.map((d: any) => {
          return [
            d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
            d['Error Applications'], d['Error Amount']
          ];
        });
  
        // Add table with headers and data
        doc.autoTable({
          startY: 35, // Start after the subtitle
          head: [headerRow2, headerRow3],
          body: dataToSave,
          theme: 'grid', // Grid layout for the table
          headStyles: { fillColor: [41, 128, 185] }, // Blue header background
          bodyStyles: { fontSize: 10 } // Body font size
        });
  
        // Save the generated PDF
        doc.save(`${filename}_export_${new Date().getTime()}.pdf`);
      });
    });
  }
  
  downloadSheetAsPdfT1(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
  
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
  
        // Title and subtitle
        const title = "Financial Progress under PDMC for MICADA Portal 2.0 (MI)";
        const downloadDate = `(Export Date: ${this.todayDate})`
        const subtitle = "Table - 1";
  
        // Add title
        doc.setFontSize(14);
        doc.text(title, 14, 15); // Title at x=14, y=15
  
        // Add download Date
        doc.setFontSize(12);
        doc.text(downloadDate, 14, 25);

        // Add subtitle
        doc.setFontSize(12);
        doc.text(subtitle, 14, 35);
  
        // Custom header rows
        const headerRow2 = [
          { content: '', colSpan: 3 }, // Empty cells for alignment
          { content: 'Success', colSpan: 2, styles: { halign: 'center' } },
          { content: 'Errors', colSpan: 2, styles: { halign: 'center' } }
        ];
  
        const headerRow3 = [
          "Activities", "F.Y.", "No.of Lots", "Applications", "Amount", "Applications", "Amount"
        ];
  
        // Mapping model data to match the Excel structure
        const dataToSave = modelData.map((d: any) => {
          return [
            d.Activities, d['F.Y.'], d['No. of Lots'], d['Success Applications'], d['Success Amount'],
            d['Error Applications'], d['Error Amount']
          ];
        });
  
        // Calculate grand totals for Success Applications, Success Amount, Error Applications, and Error Amount
        const grandTotal = {
          activities: 'Grand Total',
          successApplications: modelData.reduce((sum, d) => sum + (d['Success Applications'] || 0), 0),
          successAmount: modelData.reduce((sum, d) => sum + (d['Success Amount'] || 0), 0),
          errorApplications: modelData.reduce((sum, d) => sum + (d['Error Applications'] || 0), 0),
          errorAmount: modelData.reduce((sum, d) => sum + (d['Error Amount'] || 0), 0)
        };
  
        // Add grand total row to the data
        // dataToSave.push([
        //   { content: grandTotal.activities, colSpan: 3 }, // Colspan applied to the first cell
        //   '', '', grandTotal.successApplications, grandTotal.successAmount,
        //   grandTotal.errorApplications, grandTotal.errorAmount
        // ]);
  
        // Add table with headers and data
        doc.autoTable({
          startY: 45, // Start after the subtitle
          head: [headerRow2, headerRow3],
          body: dataToSave,
          theme: 'grid', // Grid layout for the table
          headStyles: { fillColor: [41, 128, 185] }, // Blue header background
          bodyStyles: { fontSize: 10 }, // Body font size
          columnStyles: {
            3: { fillColor: [144, 238, 144] }, // Light green for "Success Applications"
            4: { fillColor: [144, 238, 144] }, // Light green for "Success Amount"
            5: { fillColor: [255, 182, 193] }, // Light red for "Error Applications"
            6: { fillColor: [255, 182, 193] }  // Light red for "Error Amount"
          },
          foot: [[
            { content: grandTotal.activities, colSpan: 3, styles: { fillColor: [0, 0, 0], fontStyle: 'bold', textColor: [255, 255, 255] } },
            { content: grandTotal.successApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.successAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorApplications, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } },
            { content: grandTotal.errorAmount, styles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] } }
          ]],
          footStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255], fontStyle: 'bold' } // Black background for the Grand Total row
        });
  
        // Save the generated PDF
        doc.save(`${filename}_export_${new Date().getTime()}.pdf`);
      });
    });
  }

  

  // Methods for Table 2 (Split into Non-Tank and Tank)
  fetchDataForTable2() {
    this.loadingTable2_nonTank = true;
    this.loadingTable2_tank = true;
    // this.http.get<SubsidyData[]>('http://203.100.79.155/api1/api/Reports/GetSubsidyDistribution', {
    //   params: { FormatType: '2' }
    // })
    this.reportsService.getSubsidyData('2').subscribe(
      (data:any) => {
        // Split data into non-tank and tank
        const nonTankData = data.filter(item => !item.Activities.toLowerCase().includes('tank'));
        const tankData = data.filter(item => item.Activities.toLowerCase().includes('tank'));

        // Sort data by Activities to group them together
        this.dataFormatType2_nonTank = nonTankData.sort((a, b) => a.Activities.localeCompare(b.Activities));
        // this.dataFormatType2_tank = tankData.sort((a, b) => a.Activities.localeCompare(b.Activities));
        this.dataFormatType2_tank = tankData.sort((a, b) => {
          const activityComparison = a.Activities.localeCompare(b.Activities);
          if (activityComparison !== 0) {
            return activityComparison; // Sort by Activities if they are not equal
          }
          // If Activities are equal, sort by Financial Year
          return a['F.Y.'].localeCompare(b['F.Y.']);
        });

        // Calculate row spans and totals for non-tank data
        this.calculateRowSpan2_nonTank();
        this.calculateTotals2_nonTank();
        this.loadingTable2_nonTank = false;

        // Calculate row spans and totals for tank data
        this.calculateRowSpan2_tank();
        this.calculateTotals2_tank();
        this.loadingTable2_tank = false;
      },
      error => {
        this.loadingTable2_nonTank = false;
        this.loadingTable2_tank = false;
      }
    );
  }

  // Methods for Non-Tank Data
  calculateRowSpan2_nonTank() {
    this.rowSpan2_nonTank = {};
    let currentActivity = '';
    this.dataFormatType2_nonTank.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan2_nonTank[currentActivity] = 1;
      } else {
        this.rowSpan2_nonTank[currentActivity]++;
      }
    });
  }

  shouldShowActivities2_nonTank(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType2_nonTank[rowIndex].Activities;
    const previousActivity = this.dataFormatType2_nonTank[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals2_nonTank() {
    this.grandTotalSuccessApplications2_nonTank = this.dataFormatType2_nonTank.reduce((sum, item) => sum + item['Success Applications'], 0);
    this.grandTotalSuccessAmount2_nonTank = this.dataFormatType2_nonTank.reduce((sum, item) => sum + item['Success Amount'], 0);
    this.grandTotalErrorApplications2_nonTank = this.dataFormatType2_nonTank.reduce((sum, item) => sum + item['Error Applications'], 0);
    this.grandTotalErrorAmount2_nonTank = this.dataFormatType2_nonTank.reduce((sum, item) => sum + item['Error Amount'], 0);
  }

  // Methods for Tank Data
  calculateRowSpan2_tank() {
    this.rowSpan2_tank = {};
    let currentActivity = '';
    this.dataFormatType2_tank.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan2_tank[currentActivity] = 1;
      } else {
        this.rowSpan2_tank[currentActivity]++;
      }
    });
  }

  shouldShowActivities2_tank(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType2_tank[rowIndex].Activities;
    const previousActivity = this.dataFormatType2_tank[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals2_tank() {
    this.grandTotalSuccessApplications2_tank = this.dataFormatType2_tank.reduce((sum, item) => sum + item['Success Applications'], 0);
    this.grandTotalSuccessAmount2_tank = this.dataFormatType2_tank.reduce((sum, item) => sum + item['Success Amount'], 0);
    this.grandTotalErrorApplications2_tank = this.dataFormatType2_tank.reduce((sum, item) => sum + item['Error Applications'], 0);
    this.grandTotalErrorAmount2_tank = this.dataFormatType2_tank.reduce((sum, item) => sum + item['Error Amount'], 0);
  }

  // Methods for Table 3 (FormatType=3)
  fetchDataForTable3() {
    this.loadingTable3 = true;
    // this.http.get<any[]>('http://203.100.79.155/api1/api/Reports/GetSubsidyDistribution', {
    //   params: { FormatType: '3' }
    // })
    this.reportsService.getSubsidyData('3').subscribe(
      (data:any) => {
        // Map data to match our interface
        this.dataFormatType3 = data.map(item => {
          const applications2022 = item['2022-23Apps'] || 0;
          const amount2022 = item['2022-23_Success_Amount'] || 0;
          const applications2023 = item['2023-24Apps'] || 0;
          const amount2023 = item['2023-24_Success_Amount'] || 0;
          const applications2024 = item['2024-25Apps'] || 0;
          const amount2024 = item['2024-25_Success_Amount'] || 0;
          const applications_ = item['-Apps'] || 0;
          const amount_ = item['-_Success_Amount'] || 0;

          const totalApplications = applications2022 + applications2023 + applications2024 + applications_;
          const totalAmount = amount2022 + amount2023 + amount2024 + amount_;

          return {
            Activities: item.LotType || 'N/A',
            'Applications -': applications_,
            'Amount -': amount_,
            'Applications 2022-23': applications2022,
            'Amount 2022-23': amount2022,
            'Applications 2023-24': applications2023,
            'Amount 2023-24': amount2023,
            'Applications 2024-25': applications2024,
            'Amount 2024-25': amount2024,
            'Total Applications': totalApplications,
            'Total Amount': totalAmount
          };
        });

        // Calculate grand totals
        this.calculateTotals3();

        this.loadingTable3 = false;
      },
      error => {
        this.loadingTable3 = false;
      }
    );
  }

  calculateTotals3() {
    const fields = [
      'Applications -', 'Amount -',
      'Applications 2022-23', 'Amount 2022-23',
      'Applications 2023-24', 'Amount 2023-24',
      'Applications 2024-25', 'Amount 2024-25',
      'Total Applications', 'Total Amount'
    ];

    // Initialize totals
    fields.forEach(field => this.grandTotals3[field] = 0);

    // Calculate totals
    this.dataFormatType3.forEach(item => {
      fields.forEach(field => {
        this.grandTotals3[field] += item[field];
      });
    });
  }

  // Methods for Table 4
  fetchDataForTable4() {
    this.loadingTable4 = true;
    // this.http.get<SubsidyData[]>('http://203.100.79.155/api1/api/Reports/GetSubsidyDistribution', {
    //   params: { FormatType: '4' }
    // })
    this.reportsService.getSubsidyData('4').subscribe(
      (data:any) => {
        // Sort data by Activities to group them together
        this.dataFormatType4 = data.sort((a, b) => a.Activities.localeCompare(b.Activities));
        this.calculateRowSpan4(); // Calculate rowspans after data is sorted
        this.loadingTable4 = false;
        this.calculateTotals4();
      },
      error => {
        this.loadingTable4 = false;
      }
    );
  }

  calculateRowSpan4() {
    this.rowSpan4 = {};
    let currentActivity = '';
    this.dataFormatType4.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan4[currentActivity] = 1;
      } else {
        this.rowSpan4[currentActivity]++;
      }
    });
  }

  shouldShowActivities4(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType4[rowIndex].Activities;
    const previousActivity = this.dataFormatType4[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals4() {
    this.grandTotalSuccessApplications4 = this.dataFormatType4.reduce((sum, item) => sum + item['Success Applications'], 0);
    this.grandTotalSuccessAmount4 = this.dataFormatType4.reduce((sum, item) => sum + item['Success Amount'], 0);
    this.grandTotalErrorApplications4 = this.dataFormatType4.reduce((sum, item) => sum + item['Error Applications'], 0);
    this.grandTotalErrorAmount4 = this.dataFormatType4.reduce((sum, item) => sum + item['Error Amount'], 0);
    this.grandTotalNoOfLots4 = this.dataFormatType4.reduce((sum, item) => sum + (item['No. of Lots'] || 0), 0);
  }

  // Methods for Table 5
  fetchDataForTable5() {
    this.loadingTable5 = true;
    // this.http.get<any[]>('http://203.100.79.155/api1/api/Reports/GetSubsidyDistribution', {
    //   params: { FormatType: '5' }
    // })
    this.reportsService.getSubsidyData('5').subscribe(
      (data:any) => {

        // caste wise lot count
        let lotCountByCaste = data.reduce((acc, item) => {
          const caste = item.Caste_Description || 'Unknown'; // Use 'Unknown' for null or undefined Caste_Description
          acc[caste] = (acc[caste] || 0) + 
                       (item["Lots -"] || 0) + 
                       (item["Lots 2022-23"] || 0) + 
                       (item["Lots 2023-24"] || 0) + 
                       (item["Lots 2024-25"] || 0);
          return acc;
        }, {});
      
        // Convert object to array of objects
        this.casteWiseDataType5 = Object.entries(lotCountByCaste).map(([key, value]) => ({
          Caste: key,
          Count: value
        }));

        // Display the result
      
        // Map data to match our interface
        this.dataFormatType5 = data.map(item => ({
          Activities: item.Activities,
          Type: item.Caste_Description || 'N/A',

          'Lots -': item['Lots -'] || 0,
          'Success Applications -': item['Success Applications -'] || 0,
          'Success Amount -': item['Success Amount -'] || 0,
          'Error Applications -': item['Error Applications -'] || 0,
          'Error Amount -': item['Error Amount -'] || 0,

          'Lots 2022-23': item['Lots 2022-23'] || 0,
          'Success Applications 2022-23': item['Success Applications 2022-23'] || 0,
          'Success Amount 2022-23': item['Success Amount 2022-23'] || 0,
          'Error Applications 2022-23': item['Error Applications 2022-23'] || 0,
          'Error Amount 2022-23': item['Error Amount 2022-23'] || 0,

          'Lots 2023-24': item['Lots 2023-24'] || 0,
          'Success Applications 2023-24': item['Success Applications 2023-24'] || 0,
          'Success Amount 2023-24': item['Success Amount 2023-24'] || 0,
          'Error Applications 2023-24': item['Error Applications 2023-24'] || 0,
          'Error Amount 2023-24': item['Error Amount 2023-24'] || 0,

          'Lots 2024-25': item['Lots 2024-25'] || 0,
          'Success Applications 2024-25': item['Success Applications 2024-25'] || 0,
          'Success Amount 2024-25': item['Success Amount 2024-25'] || 0,
          'Error Applications 2024-25': item['Error Applications 2024-25'] || 0,
          'Error Amount 2024-25': item['Error Amount 2024-25'] || 0,
        }));

        // Sort data by Activities
        this.dataFormatType5.sort((a, b) => a.Activities.localeCompare(b.Activities));
        this.calculateRowSpan5();
        this.calculateTotals5();
        this.loadingTable5 = false;
      },
      error => {
        this.loadingTable5 = false;
      }
    );
  }

  calculateRowSpan5() {
    this.rowSpan5 = {};
    let currentActivity = '';
    this.dataFormatType5.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan5[currentActivity] = 1;
      } else {
        this.rowSpan5[currentActivity]++;
      }
    });
  }

  shouldShowActivities5(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType5[rowIndex].Activities;
    const previousActivity = this.dataFormatType5[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals5() {
    const fields = [
      'Lots -', 'Success Applications -', 'Success Amount -',
      'Error Applications -', 'Error Amount -',
      'Lots 2022-23', 'Success Applications 2022-23', 'Success Amount 2022-23',
      'Error Applications 2022-23', 'Error Amount 2022-23',
      'Lots 2023-24', 'Success Applications 2023-24', 'Success Amount 2023-24',
      'Error Applications 2023-24', 'Error Amount 2023-24',
      'Lots 2024-25', 'Success Applications 2024-25', 'Success Amount 2024-25',
      'Error Applications 2024-25', 'Error Amount 2024-25',
    ];

    // Initialize totals
    fields.forEach(field => this.grandTotals5[field] = 0);

    // Calculate totals
    this.dataFormatType5.forEach(item => {
      fields.forEach(field => {
        this.grandTotals5[field] += item[field];
      });
    });
  }

  // Methods for Table 6
  fetchDataForTable6() {
    this.loadingTable6 = true;
    // this.http.get<any[]>('http://203.100.79.155/api1/api/Reports/GetSubsidyDistribution', {
    //   params: { FormatType: '6' }
    // })
    this.reportsService.getSubsidyData('6').subscribe(
      (data:any) => {
        // Map data to match our interface
        let value = data.map(item => ({
          Activities: item.Activities,
          Type: item.Program_Name || 'N/A',

          'Lots -': item['Lots -'] || 0,
          'Success Applications -': item['Success Applications -'] || 0,
          'Success Amount -': item['Success Amount -'] || 0,
          'Error Applications -': item['Error Applications -'] || 0,
          'Error Amount -': item['Error Amount -'] || 0,

          'Lots 2022-23': item['Lots 2022-23'] || 0,
          'Success Applications 2022-23': item['Success Applications 2022-23'] || 0,
          'Success Amount 2022-23': item['Success Amount 2022-23'] || 0,
          'Error Applications 2022-23': item['Error Applications 2022-23'] || 0,
          'Error Amount 2022-23': item['Error Amount 2022-23'] || 0,

          'Lots 2023-24': item['Lots 2023-24'] || 0,
          'Success Applications 2023-24': item['Success Applications 2023-24'] || 0,
          'Success Amount 2023-24': item['Success Amount 2023-24'] || 0,
          'Error Applications 2023-24': item['Error Applications 2023-24'] || 0,
          'Error Amount 2023-24': item['Error Amount 2023-24'] || 0,

          'Lots 2024-25': item['Lots 2024-25'] || 0,
          'Success Applications 2024-25': item['Success Applications 2024-25'] || 0,
          'Success Amount 2024-25': item['Success Amount 2024-25'] || 0,
          'Error Applications 2024-25': item['Error Applications 2024-25'] || 0,
          'Error Amount 2024-25': item['Error Amount 2024-25'] || 0,
        }));


        this.dataFormatType4b = value.filter(
          item => item.Activities === "Farmer Share To Vendors" || item.Activities === "Refund To Farmer"
        );
        this.dataFormatType6 = value.filter(
          item => item.Activities !== "Farmer Share To Vendors" && item.Activities !== "Refund To Farmer"
        );

        // Sort data by Activities
        this.dataFormatType4b.sort((a, b) => a.Activities.localeCompare(b.Activities));
        this.dataFormatType6.sort((a, b) => a.Activities.localeCompare(b.Activities));
        this.calculateRowSpan6();
        this.calculateTotals6();
        this.calculateRowSpan4b();
        this.calculateTotals4b();
        this.loadingTable6 = false;
      },
      error => {
        this.loadingTable6 = false;
      }
    );
  }

  calculateRowSpan6() {
    this.rowSpan6 = {};
    let currentActivity = '';
    this.dataFormatType6.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan6[currentActivity] = 1;
      } else {
        this.rowSpan6[currentActivity]++;
      }
    });
  }

  shouldShowActivities6(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType6[rowIndex].Activities;
    const previousActivity = this.dataFormatType6[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals6() {
    const fields = [
      'Lots -', 'Success Applications -', 'Success Amount -',
      'Error Applications -', 'Error Amount -',
      'Lots 2022-23', 'Success Applications 2022-23', 'Success Amount 2022-23',
      'Error Applications 2022-23', 'Error Amount 2022-23',
      'Lots 2023-24', 'Success Applications 2023-24', 'Success Amount 2023-24',
      'Error Applications 2023-24', 'Error Amount 2023-24',
      'Lots 2024-25', 'Success Applications 2024-25', 'Success Amount 2024-25',
      'Error Applications 2024-25', 'Error Amount 2024-25',
    ];

    // Initialize totals
    fields.forEach(field => this.grandTotals6[field] = 0);

    // Calculate totals
    this.dataFormatType6.forEach(item => {
      fields.forEach(field => {
        this.grandTotals6[field] += item[field];
      });
    });
  }

  calculateRowSpan4b() {
    this.rowSpan4b = {};
    let currentActivity = '';
    this.dataFormatType4b.forEach(item => {
      if (item.Activities !== currentActivity) {
        currentActivity = item.Activities;
        this.rowSpan4b[currentActivity] = 1;
      } else {
        this.rowSpan4b[currentActivity]++;
      }
    });
  }

  shouldShowActivities4b(rowIndex: number): boolean {
    if (rowIndex === 0) {
      return true;
    }
    const currentActivity = this.dataFormatType4b[rowIndex].Activities;
    const previousActivity = this.dataFormatType4b[rowIndex - 1].Activities;
    return currentActivity !== previousActivity;
  }

  calculateTotals4b() {
    const fields = [
      'Lots -', 'Success Applications -', 'Success Amount -',
      'Error Applications -', 'Error Amount -',
      'Lots 2022-23', 'Success Applications 2022-23', 'Success Amount 2022-23',
      'Error Applications 2022-23', 'Error Amount 2022-23',
      'Lots 2023-24', 'Success Applications 2023-24', 'Success Amount 2023-24',
      'Error Applications 2023-24', 'Error Amount 2023-24',
      'Lots 2024-25', 'Success Applications 2024-25', 'Success Amount 2024-25',
      'Error Applications 2024-25', 'Error Amount 2024-25',
    ];

    // Initialize totals
    fields.forEach(field => this.grandTotals4b[field] = 0);

    // Calculate totals
    this.dataFormatType4b.forEach(item => {
      fields.forEach(field => {
        this.grandTotals4b[field] += item[field];
      });
    });
  }

  onClickTable1(val){
    this.selectedRowVal = null;
    this.showTable1Lot = false;
    this.showSubsidyToFarmer = false;
    this.showSubsidyToVendor = false;

    if(val?.Activities.startsWith('Subsidy To Farmer')){
      this.selectedRowVal = val;
      this.showTable1Lot = true;
      this.showSubsidyToFarmer = true;
    }else if(val?.Activities.startsWith('Subsidy To Vendor')){
      this.selectedRowVal = val;
      this.showTable1Lot = true;
      this.showSubsidyToVendor = true;
    }
  }

  onClickTable2(val){
    this.selectedRowVal = null;
    this.showTable2Lot = false;
    this.showTanksS1 = false;
    this.showTanksS2 = false;
    this.showTanksS3 = false;

    if(val?.Activities.startsWith('Tank 1')){
      this.selectedRowVal = val;
      this.showTable2Lot = true;
      this.showTanksS1 = true;
    }else if(val?.Activities.startsWith('Tank 2')){
      this.selectedRowVal = val;
      this.showTable2Lot = true;
      this.showTanksS2 = true;
    }else if(val?.Activities.startsWith('Tank 3')){
      this.selectedRowVal = val;
      this.showTable2Lot = true;
      this.showTanksS3 = true;
    }
  }

  onClickTable4(val){
    this.selectedRowVal = null;
    this.showTable4Lot = false;
    this.showRefundToFarmer = false;
    this.showFarmerShareToVendor = false;

    if(val?.Activities.startsWith('Refund To Farmer')){
      this.selectedRowVal = val;
      this.showTable4Lot = true;
      this.showRefundToFarmer = true;
    }else if(val?.Activities.startsWith('Farmer Share To Vendors')){
      this.selectedRowVal = val;
      this.showTable4Lot = true;
      this.showFarmerShareToVendor = true;
    }
  }

  onCloseDialogT1(){
    this.showTable1Lot = false;
    this.selectedRowVal = {};
    this.showSubsidyToFarmer = false;
    this.showSubsidyToVendor = false;
  }

  onCloseDialogT2(){
    this.showTable2Lot = false;
    this.selectedRowVal = {};
    this.showTanksS1 = false;
    this.showTanksS2 = false;
    this.showTanksS3 = false;
  }

  onCloseDialogT4(){
    this.showTable4Lot = false;
    this.selectedRowVal = {};
    this.showFarmerShareToVendor = false;
    this.showRefundToFarmer = false;
  }

  public selectedDDRowVal: any;

  getDrillDownData(val, tableNo, status, count, ...finYear){
    if(count <= 0){
      this.messageService.add({severity:'info', summary:'Info', detail:'Data Not Available'});
      return;
    }
    if(tableNo == 6){
      val.Program_Name = val.Type
    }
    if(tableNo == 5){
      val.Caste_Description = val.Type
    }
    this.selectedDDRowVal = null;   

    this.drillDownReqDetails = {
      selectedRow: val,
      formatType: tableNo,
      status: status,
      finYear: finYear[0]
    }

    this.showDrillDownReport = true;
    // if(val?.Activities.startsWith('Subsidy To Farmer')){
    //   this.selectedDDRowVal = val;
    //   // this.showTable1Lot = true;
    //   // this.showSubsidyToFarmer = true;
    // }else if(val?.Activities.startsWith('Subsidy To Vendor')){
    //   this.selectedDDRowVal = val;
    //   // this.showTable1Lot = true;
    //   // this.showSubsidyToVendor = true;
    // }
  }

  onCloseDDReport(){
    this.showDrillDownReport = false;
  }

  doNothing(){

  }
}
